import React from 'react';
import styles from './StandardContent.module.scss';

const StandardContent: React.FunctionComponent = ({ children }) => {
  return <div className={styles.component}>{children}</div>;
};

export default StandardContent;
